// @file GraphQL Queries and Mutations for Folder type
import gql from 'graphql-tag'

export const CREATE_FOLDER: any = gql`
  mutation ($name: String!) {
    upsertFolder(name: $name) {
      id
      name
      walls_count
      owner_id
    }
  }
`

export const UPDATE_FOLDER: any = gql`
  mutation ($folderId: ID!, $name: String!) {
    upsertFolder(name: $name, id: $folderId) {
      id
      name
      walls_count
      owner_id
    }
  }
`

export const DELETE_FOLDER: any = gql`
  mutation ($folderId: ID!) {
    deleteFolder(id: $folderId) {
      id
      name
      walls_count
      owner_id
    }
  }
`
